__turbopack_context__.v({
  "main": "LTwoColsLeft-module__2Snc1W__main",
  "root": "LTwoColsLeft-module__2Snc1W__root",
  "sidebar": "LTwoColsLeft-module__2Snc1W__sidebar",
});
